import script from "./InputOtherTrouble.vue?vue&type=script&setup=true&lang=js"
export * from "./InputOtherTrouble.vue?vue&type=script&setup=true&lang=js"

import "./InputOtherTrouble.vue?vue&type=style&index=0&id=90cb072c&lang=css"

const __exports__ = script;

export default __exports__